export enum FullcircleSyncMode {
  FULL = 'full',
  PRICE_ONLY = 'price_only',
}
